import React from 'react';
import ButtonsPage from '@pages-clean/dummy-page/pages/buttons-page';
import CheckboxesPage from '@pages-clean/dummy-page/pages/checkboxes-page';
import ChipListPage from '@pages-clean/dummy-page/pages/chip-list-page';
import TogglesPage from '@pages-clean/dummy-page/pages/toggle-page';

interface ControlsPageProps {
    isDisabled: boolean;
}
const ControlsPage = ({ isDisabled }: ControlsPageProps) => {
    return (
        <>
            <h2>Buttons</h2>
            <ButtonsPage isDisabled={isDisabled} />
            <br />
            <h2>Checkboxes</h2>
            <CheckboxesPage isDisabled={isDisabled} />
            <br />
            <h2>Chip List</h2>
            <ChipListPage isDisabled={isDisabled} />
            <br />
            <h2>Toggle</h2>
            <TogglesPage isDisabled={isDisabled} />
        </>
    );
};

export default ControlsPage;
